import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import DoNotMountComponent from "../DoNotMountComponent/DoNotMountComponent";
import SocialLink, { PropsSocialLink } from "./SocialLink/SocialLink";

interface PropsSocialsLinksList {
  socialLinkList?: string[];
  settings?: Partial<PropsSocialLink>;
}
const SocialLinksList: React.FC<PropsSocialsLinksList> = (props: PropsSocialsLinksList) => {
  // if (!props.socialLinkList) return <DoNotMountComponent sms={"no hay link de RRSS"} log={props} />;
  const data: Queries.settingsQuery = useStaticQuery(graphql`
    query settings {
      settings: sanitySetting {
        socialLinks
      }
    }
  `);
  const linkLists: string[] | null | undefined = props.socialLinkList ?? (data.settings?.socialLinks as string[]);
  if (!linkLists || linkLists.length < 1) return <></>;
  const socialLinkList: PropsSocialLink[] = linkLists.map((socialLink): PropsSocialLink => {
    return {
      url: socialLink,
    };
  });
  return (
    <div className={"m-social-link-list"}>
      <ul className={"social-link-list"}>
        {socialLinkList.map((link: PropsSocialLink, index: number) => (
          <li key={index} className={"social-link-list__item"}>
            <SocialLink {...link} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinksList;
